import { Box } from '@mui/material';
import keyBy from 'lodash/keyBy';
import { useSelector } from 'react-redux';
import { selectAccountUsers } from '../../../../reducers/accountUsersReducer';
import { colors, Tooltip, Typography } from '@sweep-io/sweep-design';
import { User, SweepSolid } from '@sweep-io/sweep-design/dist/icons';

interface PromptAuthorProps {
  userId?: string;
  isSweep?: boolean;
}

export const PromptAuthor = ({ userId, isSweep }: PromptAuthorProps) => {
  const accountUsers = keyBy(useSelector(selectAccountUsers), 'id');
  const user = userId ? accountUsers[userId] : undefined;

  if (isSweep) {
    return (
      <Tooltip title="Sweep">
        <Box display="flex" gap={0.5} alignItems="center" overflow="hidden">
          <SweepSolid size="medium" color={colors.grey[700]} />
          <Box
            component="span"
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            <Typography variant="body">Sweep</Typography>
          </Box>
        </Box>
      </Tooltip>
    );
  }

  if (!user) return null;

  return (
    <Tooltip title={user.name}>
      <Box display="flex" gap={0.5} alignItems="center" overflow="hidden">
        <User size="medium" color={colors.grey[700]} />
        <Box
          component="span"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <Typography variant="body">{user.name}</Typography>
        </Box>
      </Box>
    </Tooltip>
  );
};
